// extracted by mini-css-extract-plugin
export default {"row":"ViewsNotifications_row__FWR7Q"};